import useFilterRegistry from './useFilterRegistry'

export default { useFilterRegistry }